import { render, staticRenderFns } from "./AddAuctionItem.vue?vue&type=template&id=157f0e50&scoped=true&"
import script from "./AddAuctionItem.vue?vue&type=script&lang=js&"
export * from "./AddAuctionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157f0e50",
  null
  
)

export default component.exports